export default {
  termsOfUse: '個人情報保護方針',
  privacyPolicy: 'クッキーポリシー',
  cookiesPolicy: 'ご利用規約',
  careers: 'キャリア',

  connectSocialMedia: 'ソーシャルメディアでつながる',
  copyright: 'Copyright',
  mtgAllRightsReserved: 'Cactus Communications. All rights reserved',
};
